import React from 'react';
import './App.css';
import {Typography, Paper, Box} from '@material-ui/core/';
import {
  BrowserRouter, Route, Switch
} from 'react-router-dom';

import Ally from './components/Ally/ally';
import Restaurant from './components/Restaurant/Restaurant'
import LandingPage from './components/LandingPage/LandingPage'
import CurrentPartnerCalculator from './components/CurrentPartnerCalculator/CurrentPartnerCalculator'
import NotPartnerCalculator from './components/NotPartnerCalculator/NotPartnerCalculator'

class App extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      isRestaurant: false,
      isAlly: false
    }
  }

  render() {
    return (
      <BrowserRouter>
      <div className="App">
        <Paper>
          <Box borderBottom={1} borderColor='error.main'>
          <Typography variant='h1' mt={5} gutterBottom>Gig Workers Collective</Typography>
          </Box>
          <Switch>
            <Route path='/restaurant/independent' component={NotPartnerCalculator} />
            <Route path='/restaurant/currentpartner' component={CurrentPartnerCalculator} />
            <Route path="/ally" component={Ally}/>
            <Route path="/restaurant" component={Restaurant} />
            <Route path="/" component={LandingPage}/>
          </Switch>
        </Paper>
      </div>
      </BrowserRouter>
    );
  }
}

export default App;
